import { c as _c } from "react/compiler-runtime";
import type { TenantScope } from '@onefootprint/request-types/dashboard';
import useSession from '../use-session';
const usePermissions = () => {
  const $ = _c(15);
  const session = useSession();
  const {
    user
  } = session.data;
  let t0;
  if ($[0] !== user?.scopes) {
    t0 = user?.scopes || [];
    $[0] = user?.scopes;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const scopes = t0;
  let t1;
  if ($[2] !== scopes) {
    t1 = scopes.some(_temp);
    $[2] = scopes;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isAdmin = t1;
  const isAuditor = !!user?.isAuditor;
  let t2;
  if ($[4] !== user?.auditorEntityTags) {
    t2 = user?.auditorEntityTags ?? [];
    $[4] = user?.auditorEntityTags;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const auditorEntityTags = t2;
  let t3;
  if ($[6] !== isAdmin || $[7] !== scopes) {
    t3 = scopeKind => isAdmin || scopes.some(s_0 => s_0.kind === scopeKind);
    $[6] = isAdmin;
    $[7] = scopes;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const hasPermission = t3;
  let t4;
  if ($[9] !== auditorEntityTags || $[10] !== hasPermission || $[11] !== isAdmin || $[12] !== isAuditor || $[13] !== scopes) {
    t4 = {
      hasPermission,
      scopes,
      isAdmin,
      isAuditor,
      auditorEntityTags
    };
    $[9] = auditorEntityTags;
    $[10] = hasPermission;
    $[11] = isAdmin;
    $[12] = isAuditor;
    $[13] = scopes;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
export default usePermissions;
function _temp(s) {
  return s.kind === "admin";
}